import { fromJS } from 'immutable';

import { FILTRATION_SUCCESS } from '../filters/constants';
import {
  PAGINATION_SUCCESS,
  SHOW_MORE,
  SET_CURRENT_VISIBLE_HOTELS,
} from './constants';

const initialState = fromJS({
  hotels: [],
  currentPage: 0,
  hotelsCount: 20,
  currentVisibleHotels: [],
  awaitingPagination: false,
});

export default function hotelReducer(state = initialState, action) {
  switch (action.type) {
    case FILTRATION_SUCCESS: {
      return state.merge({
        hotels: action.payload.hotels,
        currentPage: 0,
        hotelsCount: action.payload.hotelsCount,
        awaitingPagination: false,
        filtered_hotels: action.payload.filtered_hotels,
      });
    }
    case SHOW_MORE: {
      const { currentPage } = state.toJS();
      return state.merge({
        awaitingPagination: true,
        currentPage: currentPage + 1,
      });
    }
    case PAGINATION_SUCCESS: {
      const { resultHotels, hotels_count } = action.payload;
      const { hotels } = state.toJS();
      return state.mergeDeep({
        hotels: [...hotels, ...resultHotels],
        hotelCount: hotels_count,
        awaitingPagination: false,
      });
    }
    case SET_CURRENT_VISIBLE_HOTELS: {
      return state.merge({
        currentVisibleHotels: action.payload,
      });
    }
    default:
      return state;
  }
}
